import type { TrigKey } from './keys';

export const gu: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'ગણિત · ત્રિકોણમિતિ',
  'panel.experiment': 'પ્રયોગ',
  'panel.params': 'પેરામીટર',
  'panel.scene': 'પ્રયોગ પસંદ કરો',
  'experiment.right-triangle.label': 'કાટખૂણ ત્રિકોણ',
  'experiment.unit-circle.label': 'એકમ વર્તુળ',
  'experiment.wave-studio.label': 'તરંગ સ્ટુડિયો',
  'experiment.identity-playground.label': 'સમવિચારો',
  'experiment.triangle-solver.label': 'ત્રિકોણ ઉકેલક',
  'experiment.circular-polar.label': 'ગોળાકાર અને ધ્રુવીય',
  'hint.line1': 'બિંદુ ખેંચો અને સ્લાઇડર ચલાવો.',
  'hint.line2': 'શૈક્ષણિક સામગ્રી ભૂમિતિમાં રહે છે, લખાણમાં નહીં.',
  'rt.angle.a': 'ખૂણો A',
  'rt.angle.b': 'ખૂણો B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'રેડિયન',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° પર સ્નેપ',
  'uc.units': 'એકમ',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC બતાવો',
  'uc.snap.common': 'સામાન્ય ખૂણા પર સ્નેપ',
  'uc.angle.value': '∠',
  'uc.units.deg': 'ડિગ્રી',
  'uc.units.rad': 'રેડ',
  'uc.units.both': 'ડિગ્રી+રેડ',
  'ws.fn': 'ફંક્શન',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — આયામ',
  'ws.frequency': 'B — આવર્તન',
  'ws.phase': 'C — તબક્કા-ખસેડ',
  'ws.shift': 'D — ઊભી ખસેડ',
  'ws.rform.toggle': 'R-સ્વરૂપ',
  'ws.rform.a': 'a (sin ગુણાંક)',
  'ws.rform.b': 'b (cos ગુણાંક)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'રીસેટ',
  'ws.base': 'મૂળ વક્ર',
  'ip.id.pythagorean': 'પાયથાગોરસ',
  'ip.id.reciprocal': 'વ્યુત્ક્રમ',
  'ip.id.quotient': 'ભાગ',
  'ip.id.sum': 'સરવાળો',
  'ip.id.difference': 'તફાવત',
  'ip.id.double': 'દ્વિગુણ',
  'ip.id.half': 'અર્ધ',
  'ip.play': 'ચલાવો',
  'ip.pause': 'રોકો',
  'ip.step': 'ડગલું',
  'ip.reset': 'રીસેટ',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2 માં — આ સાબિતી માટે વધુ વિગતવાર બાંધકામ જરૂરી છે.',
  'ts.area': 'ક્ષેત્રફળ',
  'ts.sineRule': 'સાઇન નિયમ',
  'ts.cosineRule': 'કોસાઇન નિયમ',
  'ts.ambiguous.toggle': 'અસ્પષ્ટ વખતે ભૂત ત્રિકોણ',
  'ts.reset': 'સમબાજુ પર રીસેટ',
  'ts.snap.integers': 'પૂર્ણાંકોએ સ્નેપ',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'બાજુ',
  'ts.section.angles': 'ખૂણા',
  'ts.section.sineRule': 'સાઇન નિયમ',
  'ts.section.cosineRule': 'કોસાઇન નિયમ',
  'ts.section.area': 'ક્ષેત્રફળ',
  'cp.omega': 'કોણીય ઝડપ',
  'cp.plot.y': 'y દોરો (sin)',
  'cp.plot.x': 'x દોરો (cos)',
  'cp.polar.label': 'ધ્રુવ આકૃતિ',
  'cp.polar.circle': 'વર્તુળ (r = 1)',
  'cp.polar.rose': 'ગુલાબ (r = sin 3θ)',
  'cp.polar.cardioid': 'હૃદય (r = 1 + cos θ)',
  'cp.polar.limacon': 'લિમાસન (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'નાનો ખૂણો અંદાજ (sin x ≈ x)',
  'cp.play': 'ચલાવો',
  'cp.pause': 'રોકો',
  'cp.reset': 'રીસેટ',
  'cp.step': 'ડગલું π/12',
};
